export default "__VITE_ASSET__N93UKwMx__"